export enum LogSeverity {
    INFO,
    WARNING,
    ERROR
}
